module.exports = __webpack_public_path__ + "img/logo.c92e0791.svg";